import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { COMPANY_STATUS, COMPANY_STATUS_LABEL } from 'constants/company';
import { CommunityAdminListType } from 'types/communities';

const Container = styled.span`
  display: flex;
  flex-direction: column;
  margin: 2px 0px 10px 0px;
`;

const Main = styled.span`
  font-size: 14px;
  color: var(--text-primary);
`;

const Status = styled.div`
  font-size: 12px;
  color: var(--text-primary);

  &.trial {
    color: var(--inactive-orange);
  }
  &.outside {
    color: var(--text-secondary);
  }
  &.paying {
    color: var(--positive-green);
  }
`;

interface Props {
  item: CommunityAdminListType;
}

const CommunitiesTableCompany = ({ item }: Props) => {
  return (
    <Container>
      <Main>{item.company.name}</Main>
      <Status
        className={classNames({
          outside: COMPANY_STATUS.OUTSIDE_COMPANY === item.company.status,
          trial: COMPANY_STATUS.IN_TRIAL === item.company.status,
          paying: COMPANY_STATUS.PAYING_CUSTOMER === item.company.status,
        })}
      >
        {COMPANY_STATUS_LABEL[item?.company.status]}
      </Status>
    </Container>
  );
};

export default CommunitiesTableCompany;
